import { ModalCustom } from "../../../components/custom/modal-custom";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";
import PromotionCampaignBrandTable from "./promotion-campaign-type-brand-table";

interface PromotionCampaignActionsModalProps {
  isOpen: boolean;
  item?: PromotionCampaign;
  setIsOpen: (value: boolean) => void;
}

export const PromotionCampaignActionsModal = (props: PromotionCampaignActionsModalProps) => {
  const { isOpen, setIsOpen, item } = props;

  const detailBody = () => {
    if (!item) return;
    return (
      <>
        <PromotionCampaignBrandTable item={item} />
      </>
    );
  };

  return (
    <ModalCustom
      isOpen={isOpen}
      setIsOpen={(isOpen) => {
        setIsOpen(isOpen);
      }}
      titleModal={'Chi tiết loại chiến dịch khuyến mãi'}
      bodyModal={detailBody()}
      footerModal={null}
    />
  );
};
